import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlMorfologico/imprimirControlMorfologico`, method: 'POST', body: values, token: token})
}